<vs-dialog [config]="{ dialogContainerClass: 'max-w-[520px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      icon: 'flag-01',
      iconTheme: 'primary',
      title: config.escalationDialog.title,
      subtitle: config.escalationDialog.subtitle
    }"
  ></vs-dialog-header>

  <form class="flex flex-col gap-4 p-4" [formGroup]="form">
    <vs-form-field [config]="{ label: config.escalationDialog.owner }">
      <vs-select vsInput formControlName="ownerId" [config]="{ placeholder: config.escalationDialog.ownerPlaceholder }">
        <li *ngFor="let owner of staff" vs-select-option [value]="owner.ownerId">{{ owner.name }}</li>
      </vs-select>
    </vs-form-field>

    <vs-form-field [config]="{ label: config.escalationDialog.reason }">
      <textarea vsInput formControlName="reason" [placeholder]="config.escalationDialog.reasonPlaceholder"></textarea>
    </vs-form-field>
  </form>

  <div class="flex justify-end gap-2 px-4 pb-4">
    <button vs-button appearance="outline" (click)="close()">{{ config.escalationDialog.cancel }}</button>
    <button vs-button theme="primary" [disabled]="form.invalid || saving" (click)="save()">
      {{ config.escalationDialog.save }}
    </button>
  </div>
</vs-dialog>
